<template>
    <div class="new-version-alert" v-if="show_alert">
        <strong>Terdapat Versi Baru.</strong> Silakan refresh halaman atau tekan tombol berikut
        <button class="btn btn-secondary btn-sm" @click="reload">Refresh</button>
    </div>
</template>

<script>
export default {
    name: 'VersionAlert',
    data() {
        return {
            show_alert: false,
            new_version: null,
        }
    },
    mounted() {
        window.addEventListener('beforeunload', () => {
            if(this.show_alert && this.new_version) {
                localStorage.setItem('__izdv__', this.new_version);
            }
        })

        this.$root.$on('app_version', (version) => {
            if(localStorage.getItem('__izdv__') != version) {
                this.show_alert = true;
                this.new_version = version;
            }
        })
    },
    methods: {
        reload() {
            localStorage.setItem('__izdv__', this.new_version);
            window.location.reload();
        }
    }
}
</script>

<style scoped>
.new-version-alert {
    position: absolute;
    width: 100%;
    padding: 1.75rem 1rem;
    background: #1272DB;
    z-index: 9999;
    text-align: center;
    color: #f8f9ff;
    top: 0;
    left: 0;
    box-shadow: 0 3px 3px rgba(0,0,0,0.25);
    -webkit-box-shadow: 0 3px 3px rgba(0,0,0,0.25);
    -moz-box-shadow: 0 3px 3px rgba(0,0,0,0.75);
}
</style>